import React, { useState, useRef } from "react";
import { Oval } from 'react-loader-spinner'
import { LAYOUT } from "../constants.js";
import useSettingsState from "../hooks/useSettingsState.js";

const initialState = {
  layout: LAYOUT.FLUID,
};

const LayoutContext = React.createContext(initialState);

function LayoutProvider({ children }) {
  const [layout, setLayout] = useSettingsState("layout", LAYOUT.FLUID);
  const [loading, setLoading] = useState(false)
  const scrollContainerRef = useRef()

  // Removed problematic useEffect that was causing unnecessary eventList dispatches on navigation

  return (
    <LayoutContext.Provider
      value={{
        layout,
        setLayout,
        setLoading,
        scrollContainerRef
      }}
    >
      {children}
      {loading && <div className="loadingScreenProtection">
        <Oval
          visible={true}
          height="60"
          width="60"
          color={"#000"}
          ariaLabel="oval-loading"
        /></div>}
    </LayoutContext.Provider>
  );
}

export { LayoutProvider, LayoutContext };
